import { render } from "./BulkLinkCreate.vue?vue&type=template&id=7833a078&scoped=true"
import script from "./BulkLinkCreate.vue?vue&type=script&lang=js"
export * from "./BulkLinkCreate.vue?vue&type=script&lang=js"

import "./BulkLinkCreate.vue?vue&type=style&index=0&id=7833a078&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7833a078"]])

export default __exports__